import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function D({ tags }: any) {
    const { useLang, gtm } = useGlobal();
    const { t } = useLang('powerbackup');

    return (
        <div id="power-backup-D" className={`power-backup-D ef-layer ${css['power-backup-D']}`}>
            <div className="text-box">
                <p className="title">{t('secD_title')}</p>
            </div>
            <div className="tags">
                {tags?.map((tag: any, k: number) => (
                    <a
                        className="tag"
                        href={tag?.link}
                        key={k}
                        onClick={() =>
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'tab_click',
                                button_name: tag?.text,
                                list_name: t('secD_title'),
                            })
                        }
                    >
                        {tag?.text}
                    </a>
                ))}
            </div>
        </div>
    );
}
